document.addEventListener("DOMContentLoaded", () => {
    const isBundleError = () =>
        document.querySelector(".bundleError")?.value === "true";
    const isBundleSoldOut = () =>
        document.querySelector(".bundleSoldOut")?.value === "true";
    const isBundleBlocked = () => isBundleError() || isBundleSoldOut();
    const handleChangeChildVariant = () => {
        let completedBundle = 0;
        document
            .querySelectorAll(".childProductValue:checked")
            .forEach((value, index) => {
                const jsonData = JSON.parse(value.value) ?? null;
                if (jsonData.variantid == "selectVariant") {
                    completedBundle++;
                } else {
                    const currentSelectBox = value.closest(
                        ".individual-variant-select-box__current"
                    );
                    if (currentSelectBox) {
                        const valueSelect = currentSelectBox.querySelector(
                            ".individual-variant-select-box__input-text"
                        );
                        const icon = currentSelectBox.querySelector(
                            ".individual-variant-select-box__icon"
                        );
                        const iconCheck = currentSelectBox.querySelector(
                            ".individual-variant-select-box__icon-check"
                        );
                        valueSelect.classList.add("selectedVariant");
                        icon.style.display = "none";
                        iconCheck.style.display = "inline";
                    }
                }
            });
        if (completedBundle == 0 && !isBundleBlocked()) {

            document
                .querySelectorAll(".product-form__submit")
                .forEach((button) => {
                    button.removeAttribute("disabled");
                    button.innerText = "ADD TO CART";

                });
        }
    };
    const handleFixedBundleClick = () => {
        const showFlag = document.querySelectorAll(
            ".fixed-bundle-checkbox:checked"
        ).length;
        document
            .querySelectorAll(".fixed-bundle-childProducts")
            .forEach((item) => {
                showFlag
                    ? item.classList.add("fixed-bundle-hidden")
                    : item.classList.remove("fixed-bundle-hidden");
            });
        document.querySelectorAll(".hiddeInfo").forEach((item) => {
            showFlag ? item.innerText("Show") : item.innerText("Hide");
        });
    };
    const handleClickShowMore = (e) => {
        const el = e.currentTarget;
        const showFlag = el.classList.contains("fixed-bundle-show-less");
        showFlag
            ? el.classList.remove("fixed-bundle-show-less")
            : el.classList.add("fixed-bundle-show-less");
        el.querySelector("span").innerText = showFlag ? "more" : "less";
        document
            .querySelectorAll(".fixed-bundle-main-selected-variants .fixed-bundle-carousel")
            .forEach((carouselContainer, carouselContainerIndex) => {
                if (carouselContainerIndex < 1) return 0;
                showFlag
                    ? carouselContainer.classList.remove("carousel-active")
                    : carouselContainer.classList.add("carousel-active");
            });
    };
    const handleQuantityChange = (e) => {
        const el = e.currentTarget;
        document
            .querySelectorAll(".quantity__input-bundles")
            .forEach((value) => {
                value.value = el.value;
            });
    };
    const handleSubmitProduct = async (e) => {
        if (isBundleBlocked()) {
            e.preventDefault();
            return;
        }
        const childItemsQuantity = Number(
            document.querySelector(".childProductItemQuantity")?.value ?? 1
        );
        document.querySelectorAll(".product-form__submit").forEach((btn) => {
            btn.disabled = true;
            btn.classList.add("loading");
        });
        const formData = { items: [] };
        const inputValues = document.querySelectorAll(
            ".childProductValue:checked"
        );
        const bundleId = document.querySelector(".bundleProduct").value;
        const quantity =
            document.querySelector(".quantity__input-bundles").value ?? 1;
        let individualKey = "";
        const preselectedProduct =
            document.querySelector(".preselectedProduct")?.value ?? null;
        const bundleImage = document.querySelector(".bundleImage").value;
        const choices = {};
        const quantitiesArray = [];
        const childIds = [];
        const childImages = [];
        const rawItem = {
            id: bundleId,
            quantity: quantity,
            properties: {
                _bundleproduct: "true",
            },
        };
        const jsonValues = uniqueJSON(
            [...inputValues].flatMap((value) => JSON.parse(value.value))
        );
        const jsonValuesSorted = sortJSON(
            jsonValues,
            "childproductname",
            "asc"
        );
        jsonValuesSorted.map((inputValue) => {
            childIds.push(inputValue.variantid);
        });
        childIds.push(bundleId);
        individualKey = generate_hash(childIds);
        jsonValuesSorted.map((inputValue) => {
            quantitiesArray.push({
                id: inputValue.variantid,
                quantity: inputValue.quantity,
            });
            childImages.push(inputValue.featured_image);
        });
        if (preselectedProduct) {
            quantitiesArray.push({
                id: preselectedProduct,
                quantity: 1,
                isPreselectedProduct: true,
            });
        }
        choices["_quantitiesarray"] = JSON.stringify(quantitiesArray);
        choices["_bundleimage"] = bundleImage;
        rawItem.properties = choices;
        formData.items.push(rawItem);
        const response = await fetch(
            window.Shopify.routes.root + "cart/add.js",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            }
        )
            .then((response) => {
                return response.json();
            })
            .catch((error) => {
                console.error("Error:", error);
            });
        if (response) {
            if (
                response.items?.length !== formData.items.length ||
                response.message !== undefined
            ) {
                // Apply retry to add - Five times
                const responseRemove = await removeFromCartByIndividualKey(
                    individualKey
                ).then((res) => res);
                if (responseRemove === true) {
                    console.error("Products removed");
                }
                const response = await retryAddProduct(formData).then(
                    (res) => res
                );
                if (response === true) {
                    console.log("Product added");
                    updateCartDrawer();
                } else {
                    console.log("Product error");
                    // Apply automatic reload and re-try add bundle
                    localStorage.setItem(
                        "bundleData",
                        JSON.stringify(formData)
                    );
                    location.reload();
                }
            } else {
                updateCartDrawer();
            }
            reactivate_btn();
        } else {
            const responseRemove = await removeFromCartByIndividualKey(
                individualKey
            ).then((res) => res);
            if (responseRemove === true) {
                console.error("Products removed");
            }
            const response = await retryAddProduct(formData).then((res) => res);
            if (response === true) {
                console.log("Product added");
                updateCartDrawer();
            } else {
                console.log("Product error");
                // Apply automatic reload and re-try add bundle
                localStorage.setItem("bundleData", JSON.stringify(formData));
                location.reload();
            }
            reactivate_btn();
        }



        function reactivate_btn() {
            for (let i = 0; i < $(".product-form__submit").length; i++) {
                let btn = $(".product-form__submit")[i];

                if (!btn.dataset.originalText) {
                    btn.dataset.originalText = btn.textContent;
                }

                btn.textContent = "ADDED";

                btn.disabled = false;
                btn.classList.remove("loading");

                setTimeout(() => {
                    btn.textContent = btn.dataset.originalText;
                }, 3000);
            }
        }

    };
    function init_bundle() {
        document
            .querySelectorAll(".childProductValue:checked")
            .forEach((value) => {
                const json = JSON.parse(value.value);

                const isOutOfStock = value.getAttribute('data-tag') === 'oos-tag';
                const childAvailable = value.getAttribute('data-child-available') || "";
                const isChildSoldOut = childAvailable.includes('childSoldOut');

                if (json.variantid == "selectVariant") {
                    document
                        .querySelectorAll(".product-form__submit")
                        .forEach((button) => {
                            if (isOutOfStock || (json.variantid == "selectVariant" && isChildSoldOut)) {
                                button.setAttribute("disabled", "");
                                button.innerText = "SOLD OUT";
                            }
                            else if (json.variantid == "selectVariant") {
                                button.setAttribute("disabled", "");
                                button.innerText = "COMPLETE BUNDLE";
                            }
                        });
                }
            });
    }
    document.querySelectorAll(".childProductValue").forEach((item) => {
        item.addEventListener("change", handleChangeChildVariant);
    });
    document.querySelectorAll(".fixed-bundle-checkbox").forEach((item) => {
        item.addEventListener("click", handleFixedBundleClick);
    });
    document.querySelectorAll(".fixed-bundle-show-more").forEach((item) => {
        item.addEventListener("click", handleClickShowMore);
    });
    document.querySelectorAll(".quantity__input-bundles").forEach((item) => {
        item.addEventListener("change", handleQuantityChange);
    });
    document.querySelectorAll(".product-form__submit").forEach((item) => {
        item.addEventListener("click", handleSubmitProduct);
    });
    init_bundle();
});

function calculate_discounted_prices(child_prices, bundle_price) {
    child_prices = child_prices.map((price) => makeDecimal(price));
    bundle_price = makeDecimal(bundle_price);

    const total_child_price = child_prices.reduce(
        (acc, price) => acc.plus(price),
        new Decimal(0)
    );

    const discount_factor = new Decimal(bundle_price).div(total_child_price);

    const discounted_prices = [];
    for (let i = 0; i < child_prices.length - 1; i++) {
        discounted_prices.push(
            Number(
                new Decimal(child_prices[i]).times(discount_factor).toFixed(0)
            )
        );
    }

    discounted_prices.push(
        Number(
            new Decimal(bundle_price)
                .minus(
                    discounted_prices.reduce(
                        (acc, price) => acc.plus(price),
                        new Decimal(0)
                    )
                )
                .toFixed(2)
        )
    );
    return discounted_prices;
}
